/** @flow */

import { default as AbsenceDetailsIcon } from "./absence-details-icon";
import { default as AbsenceRateIcon } from "./absence-rate-icon";
import { default as AbsentStaffIcon } from "./absent-staff-icon";
import { default as AdministrationIcon } from "./administration-icon";
import { default as AlertDetailsIcon } from "./alert-details-icon";
import { default as AlertRhombusIcon } from "./alert-rhombus-icon";
import { default as AlertTriangleFilledIcon } from "./alert-triangle-filled-icon";
import { default as ArrowDownIcon } from "./arrow-down-icon";
import { default as ArrowRightFatIcon } from "./arrow-right-fat-icon";
import { default as ArrowRightIcon } from "./arrow-right-icon";
import { default as BadgeCheckIcon } from "./badge-check-icon";
import { default as BallonInfoIcon } from "./ballon-info-icon";
import { default as BellIcon } from "./bell-icon";
import { default as BlockIcon } from "./block-icon";
import { default as BookAppleIcon } from "./book-apple-icon";
import { default as CalendarGridIcon } from "./calendar-grid-icon";
import { default as CalendarXIcon } from "./calendar-x-icon";
import { default as CallListIcon } from "./call-list-icon";
import { default as CallReturnIcon } from "./call-return-icon";
import { default as CircleXIcon } from "./circle-x-icon";
import { default as CircleFilled } from "./circle-filled";
import { default as CircleArrowsIcon } from "./circle-arrows-icon";
import { default as ChangeIcon } from "./change-icon";
import { default as ChartBarIcon } from "./chart-bar-icon";
import { default as ChartDynamicIcon } from "./chart-dynamic-icon";
import { default as ChartLineIcon } from "./chart-line-icon";
import { default as ChartUpwardIcon } from "./chart-upward-icon";
import { default as CheckboxIcon } from "./checkbox-icon";
import { default as CheckmarkIcon } from "./checkmark-icon";
import { default as ChronometerIcon } from "./chronometer-icon";
import { default as ClientIcon } from "./client-icon";
import { default as ClipboardIcon } from "./clipboard-icon";
import { default as CloseIcon } from "./close-icon";
import { default as CogIcon } from "./cog-icon";
import { default as CogsIcon } from "./cogs-icon";
import { default as ContextTriangleIcon } from "./context-triangle-icon";
import { default as CopyIcon } from "./copy-icon";
import { default as DataIcon } from "./data-icon";
import { default as DeskIcon } from "./desk-icon";
import { default as DisabledIcon } from "./disabled-icon";
import { default as DocCircleXIcon } from "./doc-circle-x-icon";
import { default as DrawerIcon } from "./drawer-icon";
import { default as DocumentTimeIcon } from "./document-time-icon";
import { default as DropdownCaretIcon } from "./dropdown-caret-icon";
import { default as EmployeeDetailsIcon } from "./employee-details-icon";
import { default as EmployeeIcon } from "./employee-icon";
import { default as EmployeeSearchIcon } from "./employee-search-icon";
import { default as EmptyIcon } from "./empty-icon";
import { default as EnabledIcon } from "./enabled-icon";
import { default as FocusIcon } from "./focus-icon";
import { default as FocusListIcon } from "./focus-list-icon";
import { default as FolderQuestionIcon } from "./folder-question-icon";
import { default as GaugeIcon } from "./gauge-icon";
import { default as GlassesIcon } from "./glasses-icon";
import { default as HandYesNoIcon } from "./hand-yes-no-icon";
import { default as DoorExitLeftIcon } from "./door-exit-left-icon";
import { default as DoorExitRightIcon } from "./door-exit-right-icon";
import { default as HierarchyIcon } from "./hierarchy-icon";
import { default as HierarchyChangeIcon } from "./hierarchy-change-icon";
import { default as HistoryJumpIcon } from "./history-jump-icon";
import { default as IncomingCallIcon } from "./incoming-call-icon";
import { default as KeyIcon } from "./key-icon";
import { default as KeysIcon } from "./keys-icon";
import { default as LightBulbIcon } from "./light-bulb-icon";
import { default as ListIcon } from "./list-icon";
import { default as ListPenIcon } from "./list-pen-icon";
import { default as ListCheckIcon } from "./list-check-icon";
import { default as MailIcon } from "./mail-icon";
import { default as ManagementIcon } from "./management-icon";
import { default as ManagerDetailsIcon } from "./manager-details-icon";
import { default as MedicalDetailsIcon } from "./medical-details-icon";
import { default as MonitoringDetailsIcon } from "./monitoring-details-icon";
import { default as MoveDraggerIcon } from "./move-dragger-icon";
import { default as NewIcon } from "./new-icon";
import { default as NotificationsIcon } from "./notifications-icon";
import { default as OfficeChairIcon } from "./office-chair-icon";
import { default as OutgoingCallIcon } from "./outgoing-call-icon";
import { default as OutstandingActionsIcon } from "./outstanding-actions-icon";
import { default as PageArrowDisabledIcon } from "./page-arrow-disabled-icon";
import { default as PageArrowIcon } from "./page-arrow-icon";
import { default as PalmIcon } from "./palm-icon";
import { default as PersonAddIcon } from "./person-add-icon";
import { default as PersonsSearchIcon } from "./persons-search-icon";
import { default as PersonAbsentIcon } from "./person-absent-icon";
import { default as PersonAlertIcon } from "./person-alert-icon";
import { default as PersonArrowIcon } from "./person-arrow-icon";
import { default as PersonCircleArrowIcon } from "./person-circle-arrow-icon";
import { default as PersonDistributeIcon } from "./person-distribute-icon";
import { default as PersonEyeIcon } from "./person-eye-icon";
import { default as PersonQuestionIcon } from "./person-question-icon";
import { default as PersonTalkIcon } from "./person-talk-icon";
import { default as PersonalDetailsIcon } from "./personal-details-icon";
import { default as PersonsXIcon } from "./persons-x-icon";
import { default as PhoneBookIcon } from "./phone-book-icon";
import { default as PhoneBook2Icon } from "./phone-book2-icon";
import { default as PhoneBoothIcon } from "./phone-booth-icon";
import { default as PieChartIcon } from "./pie-chart-icon";
import { default as PrintIcon } from "./print-icon";
import { default as ProfileIcon } from "./profile-icon";
import { default as PulseMonitorIcon } from "./pulse-monitor-icon";
import { default as QuestionIcon } from "./question-icon";
import { default as QuestionCircleFilledIcon } from "./question-circle-filled-icon";
import { default as RecordingIcon } from "./recording-icon";
import { default as ReferralDetailsIcon } from "./referral-details-icon";
import { default as RemovedIcon } from "./removed-icon";
import { default as ReportingIcon } from "./reporting-icon";
import { default as ReportsIcon } from "./reports-icon";
import { default as ReportsOverviewIcon } from "./reports-overview-icon";
import { default as ReturnArrowIcon } from "./return-arrow-icon";
import { default as RolodexCardIcon } from "./rolodex-card-icon";
import { default as RtwDetailsIcon } from "./rtw-details-icon";
import { default as ScriptIcon } from "./script-icon";
import { default as ScissorsIcon } from "./scissors-icon";
import { default as ServerIcon } from "./server-icon";
import { default as ServiceIcon } from "./service-icon";
import { default as ShieldLockIcon } from "./shield-lock-icon";
import { default as SignatureIcon } from "./signature-icon";
import { default as SnoozeIcon } from "./snooze-icons";
import { default as StepCheckIcon } from "./step-check-icon";
import { default as StepCircleIcon } from "./step-circle-icon";
import { default as StepTriangleIcon } from "./step-triangle-icon";
import { default as StethoscopeIcon } from "./stethoscope-icon";
import { default as TablePhoneIcon } from "./table-phone-icon";
import { default as TasksIcon } from "./tasks-icon";
import { default as ThreePersonsIcon } from "./three-persons-icon";
import { default as ToolsIcon } from "./tools-icon";
import { default as TotalIcon } from "./total-icon";
import { default as TrainingIcon } from "./training-icon";
import { default as TrendsIcon } from "./trends-icon";
import { default as UploadIcon } from "./upload-icon";
import { default as WarningCircleFilledIcon } from "./warning-circle-filled-icon";
import { default as WarningExclamatoryCircleFilledIcon } from "./warning-exclamatory-circle-filled-icon";
import { default as CustomerSupportIcon } from "./customer-support-icon";
import { default as BellIconTo } from "./bell-icon-to";
import { default as BellIconFor } from "./bell-icon-for";
import { default as WarningTriangleIcon } from "./warning-triangle-icon";

export default {
  AbsenceDetailsIcon,
  AbsenceRateIcon,
  AbsentStaffIcon,
  AdministrationIcon,
  AlertDetailsIcon,
  AlertRhombusIcon,
  AlertTriangleFilledIcon,
  ArrowDownIcon,
  ArrowRightFatIcon,
  ArrowRightIcon,
  BadgeCheckIcon,
  BallonInfoIcon,
  BellIcon,
  BlockIcon,
  BookAppleIcon,
  CalendarGridIcon,
  CalendarXIcon,
  CallListIcon,
  CallReturnIcon,
  CircleXIcon,
  CircleFilled,
  CircleArrowsIcon,
  ChangeIcon,
  ChartBarIcon,
  ChartDynamicIcon,
  ChartLineIcon,
  ChartUpwardIcon,
  CheckboxIcon,
  CheckmarkIcon,
  ChronometerIcon,
  ClientIcon,
  ClipboardIcon,
  CloseIcon,
  CogIcon,
  CogsIcon,
  ContextTriangleIcon,
  CopyIcon,
  DataIcon,
  DeskIcon,
  DisabledIcon,
  DrawerIcon,
  DocumentTimeIcon,
  DocCircleXIcon,
  DoorExitRightIcon,
  DoorExitLeftIcon,
  DropdownCaretIcon,
  EmployeeDetailsIcon,
  EmployeeIcon,
  EmployeeSearchIcon,
  EmptyIcon,
  EnabledIcon,
  FocusIcon,
  FocusListIcon,
  FolderQuestionIcon,
  GaugeIcon,
  GlassesIcon,
  HandYesNoIcon,
  HierarchyIcon,
  HierarchyChangeIcon,
  HistoryJumpIcon,
  IncomingCallIcon,
  KeyIcon,
  KeysIcon,
  LightBulbIcon,
  ListIcon,
  ListPenIcon,
  ListCheckIcon,
  MailIcon,
  ManagementIcon,
  ManagerDetailsIcon,
  MedicalDetailsIcon,
  MonitoringDetailsIcon,
  MoveDraggerIcon,
  NewIcon,
  NotificationsIcon,
  OfficeChairIcon,
  OutgoingCallIcon,
  OutstandingActionsIcon,
  PageArrowDisabledIcon,
  PageArrowIcon,
  PalmIcon,
  PersonAddIcon,
  PersonsSearchIcon,
  PersonAbsentIcon,
  PersonAlertIcon,
  PersonArrowIcon,
  PersonCircleArrowIcon,
  PersonDistributeIcon,
  PersonEyeIcon,
  PersonQuestionIcon,
  PersonTalkIcon,
  PersonalDetailsIcon,
  PersonsXIcon,
  PhoneBookIcon,
  PhoneBook2Icon,
  PhoneBoothIcon,
  PieChartIcon,
  PrintIcon,
  ProfileIcon,
  PulseMonitorIcon,
  QuestionIcon,
  QuestionCircleFilledIcon,
  RecordingIcon,
  ReferralDetailsIcon,
  RemovedIcon,
  ReportingIcon,
  ReportsIcon,
  ReportsOverviewIcon,
  ReturnArrowIcon,
  RolodexCardIcon,
  ScissorsIcon,
  RtwDetailsIcon,
  ScriptIcon,
  ServerIcon,
  ServiceIcon,
  ShieldLockIcon,
  SignatureIcon,
  SnoozeIcon,
  StepCheckIcon,
  StepCircleIcon,
  StepTriangleIcon,
  StethoscopeIcon,
  TablePhoneIcon,
  TasksIcon,
  ThreePersonsIcon,
  ToolsIcon,
  TotalIcon,
  TrainingIcon,
  TrendsIcon,
  UploadIcon,
  WarningCircleFilledIcon,
  WarningExclamatoryCircleFilledIcon,
  CustomerSupportIcon,
  BellIconTo,
  BellIconFor,
  WarningTriangleIcon,
};
